import { accordionTransitionTime } from 'consts';
import React, { ComponentType, PureComponent } from 'react';

export default <P,>(Component: ComponentType<P>) =>
  class extends PureComponent<P & IDelayUnmount & Record<string, unknown>, { shouldRender?: boolean }> {
    timeoutFn = 0;

    constructor(props) {
      super(props);
      const { isMounted } = this.props;
      this.state = {
        shouldRender: isMounted,
      };
    }

    componentDidUpdate(prevProps: IDelayUnmount) {
      const { isMounted } = this.props;
      if (prevProps.isMounted && !isMounted) {
        this.timeoutFn = window.setTimeout(() => this.setState({ shouldRender: false }), accordionTransitionTime);
      } else if (!prevProps.isMounted && isMounted) {
        clearTimeout(this.timeoutFn);
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({ shouldRender: true });
      }
    }

    render() {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { isMounted, ...rest } = this.props;
      const { shouldRender } = this.state;
      return shouldRender ? <Component {...(rest as P)} /> : false;
    }
  };
